"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDown = exports.DisabledChevronDown = exports.OptionGroupName = exports.OptionGroupWrapper = exports.Message = exports.Option = exports.DisabledOption = exports.OptionsWrapper = exports.StyledLoader = exports.SelectErrorLabel = exports.SelectLabel = exports.SelectValue = exports.SelectTextContent = exports.SelectText = exports.DisabledSelectText = exports.DisabledIconWrapper = exports.IconWrapper = exports.DisabledSelect = exports.Select = exports.DisabledSelectWrapper = exports.ErrorSelectWrapper = exports.SelectWrapper = exports.DropdownWrapper = void 0;
const ArrowDown_1 = __importDefault(require("@kawaui/icons/build/icons/navigation/ArrowDown"));
const loader_1 = __importDefault(require("@kawaui/loader"));
const styled_components_1 = __importStar(require("styled-components"));
const BORDER_WIDTH = 1;
const BORDER_WIDTH_OPEN = 2;
const ICON_SIZE = '1.5rem';
exports.DropdownWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  // @note(fernando.cervera): unstyled relative wrapper for absolute positioned label to avoid breaking stacking context;
  position: relative;

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)}
`;
const WIDTH = '336px';
exports.SelectWrapper = styled_components_1.default.div `
  ${({ isFullWidth, isNumber, theme, isOpen, size }) => (0, styled_components_1.css) `
    /* display */
    display: inline-block;

    /* box model */
    width: ${isFullWidth ? '100%' : isNumber ? '104px' : WIDTH};
    height: ${size === 'medium' ? '2.5rem' : '3rem'};
    border: ${isOpen
    ? `${BORDER_WIDTH_OPEN}px solid  ${theme.overrides.dropdown.borderColors.hover}`
    : `${BORDER_WIDTH}px solid  ${theme.overrides.dropdown.borderColors.default}`};
    border-radius: ${theme.radius.s100};
    box-sizing: border-box;

    /* color */
    background-color: ${theme.colors.background.primary};

    /* other */
    outline: none;
    user-select: none;
    cursor: pointer;

    &:focus {
      border: ${BORDER_WIDTH_OPEN}px solid ${theme.overrides.dropdown.borderColors.hover};
    }
    &:hover {
      border-color: ${theme.overrides.dropdown.borderColors.hover};
    }
  `}
`;
exports.ErrorSelectWrapper = (0, styled_components_1.default)(exports.SelectWrapper) `
  border: ${BORDER_WIDTH}px solid ${({ theme }) => theme.colors.status.error};

  &:focus {
    border: ${BORDER_WIDTH_OPEN}px solid ${({ theme }) => theme.colors.status.error};
  }
  &:hover {
    border-color: ${({ theme }) => theme.colors.status.error};
  }
`;
exports.DisabledSelectWrapper = (0, styled_components_1.default)(exports.SelectWrapper) `
  background-color: ${({ theme }) => theme.colors.gray.s200};
  border-color: ${({ theme }) => theme.overrides.dropdown.borderColors.disabled};
  cursor: not-allowed;
  color: ${({ theme }) => theme.colors.gray.s500};

  &:focus {
    border-width: ${BORDER_WIDTH}px;
  }
  &:hover {
    border-color: ${({ theme }) => theme.overrides.dropdown.borderColors.disabled};
  }
`;
exports.Select = styled_components_1.default.div `
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  color: ${({ theme }) => theme.colors.text.body};

  &:hover {
    color: ${({ theme }) => theme.colors.main.base};
  }
`;
exports.DisabledSelect = (0, styled_components_1.default)(exports.Select) `
  color: ${({ theme }) => theme.colors.gray.s500};

  &:hover {
    color: ${({ theme }) => theme.colors.gray.s500};
  }
`;
exports.IconWrapper = styled_components_1.default.div `
  display: flex;
  padding-right: ${({ theme }) => theme.space.s150};

  > svg {
    width: ${ICON_SIZE};
    height: ${ICON_SIZE};
  }
`;
exports.DisabledIconWrapper = (0, styled_components_1.default)(exports.IconWrapper) `
  > svg {
    path {
      fill: ${({ theme }) => theme.colors.gray.s300};
    }
  }
`;
exports.DisabledSelectText = styled_components_1.default.div `
  ${({ isNumber, theme }) => (0, styled_components_1.css) `
    display: flex;
    margin: 0 ${isNumber ? '0' : theme.space.s100} 0 ${theme.space.s200};
    align-items: center;
    flex: 1;

    width: calc(100% - 4.5rem);
    /* 72px is the width of the arrow + it's margin */
    ${!isNumber ? 'overflow: hidden;' : 'width: 100%;'}
  `}
`;
exports.SelectText = (0, styled_components_1.default)(exports.DisabledSelectText) `
  margin-left: ${({ isOpen, theme }) => isOpen ? `calc(${theme.space.s200} - ${BORDER_WIDTH_OPEN - BORDER_WIDTH}px)` : theme.space.s200};

  &:hover > * {
    color: ${({ theme }) => theme.colors.main.base};
  }
`;
exports.SelectTextContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  ${({ hasIcon, theme }) => (0, styled_components_1.css) `
    width: ${hasIcon ? `calc(100% - (${ICON_SIZE} + ${theme.space.s150}))` : '100%'};
  `}
`;
exports.SelectValue = styled_components_1.default.span `
  width: 100%;
  overflow: hidden;

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)};
  white-space: nowrap;
  text-overflow: ellipsis;
`;
exports.SelectLabel = styled_components_1.default.span `
  ${({ theme, isOpen }) => (0, styled_components_1.css) `
    /* positioning */
    position: absolute;
    left: ${theme.space.s100};
    top: ${isOpen ? '-11px' : '-10px'};

    /* box model */
    padding: 0 ${isOpen ? `calc(${theme.space.s100} - ${BORDER_WIDTH_OPEN - BORDER_WIDTH}px)` : theme.space.s100};

    /* text */
    ${(0, styled_components_1.css)(theme.typography.body.tinyText)};
    white-space: nowrap;

    /* color */
    background-color: ${theme.colors.background.primary};
  `}
`;
exports.SelectErrorLabel = (0, styled_components_1.default)(exports.SelectLabel) `
  color: ${({ theme }) => theme.colors.status.error};
`;
exports.StyledLoader = (0, styled_components_1.default)(loader_1.default) `
  ${({ theme }) => `
    margin-right: ${theme.space.s200};
  `}
`;
exports.OptionsWrapper = styled_components_1.default.div `
  // TODO (juan.rueda): Find a way to actually close the Dropdown instead of hiding it
  &[data-popper-reference-hidden='true'] {
    visibility: hidden;
    pointer-events: none;
  }
  ${({ theme }) => (0, styled_components_1.css) `
    max-height: 370px;
    overflow: auto;
    box-sizing: border-box;

    border: solid ${BORDER_WIDTH_OPEN}px ${theme.overrides.dropdown.borderColors.hover};
    border-radius: ${theme.radius.s100};
    box-shadow: ${theme.shadow.z3};

    ${exports.Option}:last-of-type, ${exports.DisabledOption}:last-of-type {
      border-bottom: none;
    }
  `}
`;
exports.DisabledOption = styled_components_1.default.div `
  ${({ theme, size }) => (0, styled_components_1.css) `
    /* display */
    display: flex;
    align-items: center;
    flex: 1;

    /* box model */
    min-height: 2.5rem;
    padding: ${size === 'medium' ? `${theme.space.s100} ${theme.space.s200}` : `${theme.space.s150} ${theme.space.s200}`};
    border-bottom: solid ${BORDER_WIDTH}px ${theme.colors.gray.s300};
    box-sizing: border-box;

    /* color */
    background-color: ${theme.colors.gray.s200};

    /* text */
    ${(0, styled_components_1.css)(theme.typography.body.smallText)};
    color: ${theme.colors.gray.s500};

    /* other */
    cursor: not-allowed;
  `}
`;
exports.Option = (0, styled_components_1.default)(exports.DisabledOption) `
  ${({ theme }) => (0, styled_components_1.css) `
    /* color */
    color: ${theme.colors.text.body};
    background-color: ${theme.colors.background.primary};

    /* other */
    cursor: pointer;

    &:hover {
      background-color: ${theme.colors.gray.s200};
      color: ${theme.colors.text.body};
    }
  `}
`;
exports.Message = styled_components_1.default.p `
  /* color */
  color: ${({ isError, theme }) => (isError ? theme.colors.status.error : theme.colors.text.body)};
  /* display */
  margin-top: ${({ theme }) => theme.space.s050};
  padding-left: ${({ theme }) => theme.space.s200};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.tinyText)}
`;
exports.OptionGroupWrapper = styled_components_1.default.div `
  /* color */
  background: ${({ theme }) => theme.colors.background.primary};

  /* box model */
  box-sizing: border-box;
  height: 40px;

  /* display */
  padding: 10px 16px;
`;
exports.OptionGroupName = styled_components_1.default.span `
  /* color */
  color: ${({ theme }) => theme.colors.gray.s800};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.textMain)}
`;
exports.DisabledChevronDown = (0, styled_components_1.default)(ArrowDown_1.default) `
  ${({ theme }) => (0, styled_components_1.css) `
    width: 1.25rem;
    height: 1.25rem;
    float: right;
    margin: 0 ${theme.space.s200};

    path {
      fill: ${theme.colors.gray.s500};
    }
  `}
`;
exports.ChevronDown = (0, styled_components_1.default)(exports.DisabledChevronDown) `
  transition: 0.125s ease-in-out;

  path {
    fill: ${({ theme }) => theme.colors.text.body};
  }

  ${exports.Select}:hover > & {
    path {
      fill: ${({ theme }) => theme.colors.main.base};
    }
  }
  ${({ $isOpen }) => (0, styled_components_1.css) `
    ${$isOpen ? 'transform: rotate(180deg);' : ''};
  `}
`;
